module.exports = __webpack_public_path__ + "static/img/complete_to_earn.e03efb87.png";